/* ══════════════════════════════════════════════════════════════════
   预约试骑表单的运行时

   三件事，都是「不写就少一半」的那种：

   1. **接住地图选的那家店。** 地图那一节点一张卡就派一个
      `eb:store-picked` 事件出来，这里接住、填进隐藏字段、更新右边那张卡。
      两节之间只靠这一个事件说话 —— 表单不去 DOM 里翻地图，
      地图也不知道有没有表单。
   2. **车型最多三台。** 选满之后其余的压暗禁用 ——
      比点下去没反应好，也比弹一句报错好。
   3. **签名。** 打字或手写，两栏切换。打字是默认：
      任何设备都能用，没 JS 也能用（没 JS 时手写那一栏根本不出现）。
   4. **提交。** 配了 endpoint 就走 JSON，否则走 Shopify 原生表单。

   ── 签名为什么有两条路 ──────────────────────────────────────────
   Shopify 联系表单单个字段有长度上限，一张手写签名的 data URL 经常超。
   老做法是超了就**静默换成打字那一份** —— 客户以为自己手写签了名，
   台账里却是一行文本，而且没有任何地方记录发生过替换。

   所以配了 endpoint 之后，签名**不再走 `contact[Signature]`**：
   整张 PNG 以裸 base64 放进 JSON body，没有长度天花板。
   隐藏字段只在原生表单那条兜底路上还有意义。

   ⚠️ 客户端**不上报**这三样：签署时间、免责文本的哈希、门店邮箱。
   时间和哈希由后台自己算（客户端算的哈希证明不了任何事），
   邮箱由后台拿 handle 去元对象里查 —— 免责书是签过字的法律文件，
   收件人能由页面上的隐藏字段指定的话，谁都能让我们把它寄到任意邮箱。

   页面加载时读 `?store=<handle>`：评测页的门店卡直接链过来就能预选。
   ══════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var MAX_BIKES = 3;
  /* 联系表单字段的保守上限。超过就不发图，只发打字那一份。 */
  var SIG_LIMIT = 60000;

  function init(root) {
    if (root.dataset.trReady) return;
    root.dataset.trReady = '1';

    store(root);
    bikes(root);
    signature(root);
    submit(root);
  }

  /* ── 1. 哪一家店 ────────────────────────────────────────────── */
  function store(root) {
    var input = root.querySelector('[data-tr-store]');
    var handle = root.querySelector('[data-tr-handle]');
    var card = root.querySelector('[data-tr-storecard]');
    var line = root.querySelector('[data-tr-storeline]');
    var hint = root.querySelector('[data-tr-storehint]');
    if (!input) return;

    function fill(s) {
      input.value = s.name + (s.city ? ' — ' + s.city : '');
      /* handle 才是后台认这家店的凭据：显示名会被翻译，也会被改 */
      if (handle) handle.value = s.handle || '';
      if (line) {
        line.innerHTML = (line.dataset.template || '{name}')
          .replace('{name}', '<b>' + esc(s.name) + '</b>');
      }
      if (hint) hint.textContent = s.city || '';
      if (!card) return;
      card.hidden = false;
      set(card, '[data-tr-name]', s.name);
      set(card, '[data-tr-kind]', s.kind);
      set(card, '[data-tr-address]', s.address);
      set(card, '[data-tr-hours]', s.hours);
      set(card, '[data-tr-phone]', s.phone);
      var empty = root.querySelector('[data-tr-nostore]');
      if (empty) empty.hidden = true;
    }
    /* ⚠️ 这里原来会在手机上把表单滚进视野（`eb:store-picked` 一到就滚）。
       已删（2026-08-30，Karen）——「选中一家店」和「我要预约」是两件事：
       手机上点一颗点位只是想看看这家是谁，整页却滚到下面的表单去了，
       刚点开的那张卡当场离开视野。滚动归「Book here」管，它在
       section-storemap.js 里点完自己滚，一个按钮一个结果。
       带 ?store= 进来的深链是另一回事 —— 那是奔着预约来的，见下面。 */

    document.addEventListener('eb:store-picked', function (e) { fill(e.detail); });

    /* 评测页的「Book a test ride」直接带 handle 过来。
       **只有这条路径还滚**：人是带着「我要约这家」的意图跳过来的，
       落在地图上再自己找一遍表单反而是退步。 */
    var want = new URLSearchParams(location.search).get('store');
    if (want) {
      var pre = document.querySelector('[data-shop][data-handle="' + cssEscape(want) + '"]');
      if (pre) {
        pre.click();
        if (window.matchMedia('(max-width: 768px)').matches) {
          root.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }
      }
    }
  }

  function set(scope, sel, value) {
    var el = scope.querySelector(sel);
    if (!el) return;
    el.textContent = value || '';
    var row = el.closest('[data-tr-row]');
    if (row) row.hidden = !value;
  }

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function cssEscape(s) { return String(s).replace(/["\\]/g, '\\$&'); }

  /* ── 2. 车型，最多三台 ──────────────────────────────────────── */
  function bikes(root) {
    var cells = [].slice.call(root.querySelectorAll('[data-tr-bike]'));
    var field = root.querySelector('[data-tr-bikes]');
    var counter = root.querySelector('[data-tr-count]');
    if (!cells.length) return;

    function sync() {
      var picked = cells.filter(function (c) { return c.getAttribute('aria-pressed') === 'true'; });
      cells.forEach(function (c) {
        c.disabled = picked.length >= MAX_BIKES && c.getAttribute('aria-pressed') !== 'true';
      });
      if (field) field.value = picked.map(function (c) { return c.dataset.trBike; }).join(', ');
      if (counter) {
        counter.textContent = (counter.dataset.template || '{n} of {max}')
          .replace('{n}', picked.length).replace('{max}', MAX_BIKES);
      }
    }

    root.addEventListener('click', function (e) {
      var cell = e.target.closest('[data-tr-bike]');
      if (!cell || cell.disabled) return;
      cell.setAttribute('aria-pressed', cell.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      sync();
    });
    sync();
  }

  /* ── 3. 签名 ────────────────────────────────────────────────── */
  function signature(root) {
    var box = root.querySelector('[data-tr-sig]');
    if (!box) return;

    var tabs = [].slice.call(box.querySelectorAll('[data-sig-tab]'));
    var typed = box.querySelector('[data-sig-typed]');
    var draw = box.querySelector('[data-sig-draw]');
    var field = box.querySelector('[data-sig-field]');
    var canvas = box.querySelector('canvas');
    var clear = box.querySelector('[data-sig-clear]');

    /* 没有 canvas 支持就不给「手写」这一栏 —— 给一个点了没用的按钮更糟 */
    if (!canvas || !canvas.getContext) {
      tabs.forEach(function (t) { if (t.dataset.sigTab === 'draw') t.hidden = true; });
      if (draw) draw.remove();
    }

    function show(which) {
      tabs.forEach(function (t) { t.setAttribute('aria-selected', t.dataset.sigTab === which); });
      if (typed) typed.hidden = which !== 'type';
      if (draw) draw.hidden = which !== 'draw';
      sync();
    }

    function sync() {
      if (!field) return;
      var mode = box.querySelector('[data-sig-tab][aria-selected="true"]');
      if (mode && mode.dataset.sigTab === 'draw' && canvas && dirty) {
        var url = canvas.toDataURL('image/png');
        /* 太长就退回打字那一份 —— 一个被截断的 data URL 比没有更糟 */
        field.value = url.length > SIG_LIMIT
          ? (typed ? typed.querySelector('input').value : '')
          : url;
      } else {
        field.value = typed ? typed.querySelector('input').value : '';
      }
    }

    tabs.forEach(function (t) {
      t.addEventListener('click', function () { show(t.dataset.sigTab); });
    });
    if (typed) typed.querySelector('input').addEventListener('input', sync);

    var dirty = false;
    if (canvas && canvas.getContext) {
      var ctx = canvas.getContext('2d');
      var drawing = false;
      /* 画布按显示尺寸乘 devicePixelRatio，不然在手机上是一条锯齿 */
      function size() {
        var r = canvas.getBoundingClientRect();
        var dpr = Math.min(window.devicePixelRatio || 1, 2);
        canvas.width = Math.round(r.width * dpr);
        canvas.height = Math.round(r.height * dpr);
        ctx.scale(dpr, dpr);
        ctx.lineWidth = 2.2;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.strokeStyle = getComputedStyle(canvas).color;
      }
      size();
      window.addEventListener('resize', function () { if (!dirty) size(); });

      function at(e) {
        var r = canvas.getBoundingClientRect();
        var p = e.touches ? e.touches[0] : e;
        return { x: p.clientX - r.left, y: p.clientY - r.top };
      }
      function start(e) { drawing = true; dirty = true; var p = at(e); ctx.beginPath(); ctx.moveTo(p.x, p.y); }
      function move(e) {
        if (!drawing) return;
        /* 手写时不要让页面跟着滚 */
        e.preventDefault();
        var p = at(e);
        ctx.lineTo(p.x, p.y);
        ctx.stroke();
      }
      function end() { if (!drawing) return; drawing = false; sync(); }

      canvas.addEventListener('pointerdown', start);
      canvas.addEventListener('pointermove', move);
      window.addEventListener('pointerup', end);
      canvas.addEventListener('touchstart', start, { passive: true });
      canvas.addEventListener('touchmove', move, { passive: false });
      window.addEventListener('touchend', end);

      if (clear) {
        clear.addEventListener('click', function () {
          ctx.clearRect(0, 0, canvas.width, canvas.height);
          dirty = false;
          sync();
        });
      }
    }

    /* 提交那一段问这里要签名。**不经过隐藏字段** ——
       那个字段有长度上限，而这里给的是整张图。 */
    root.trSignature = function () {
      var mode = box.querySelector('[data-sig-tab][aria-selected="true"]');
      var drawn = mode && mode.dataset.sigTab === 'draw' && canvas && dirty;
      var terms = box.querySelector('.eb-sig__terms');
      return {
        method: drawn ? 'drawn' : 'typed',
        /* 打字那份始终一起送：手写时它是签名下面那个「正楷姓名」，
           台账里两样都有才认得出这是谁 */
        typed: typed ? typed.querySelector('input').value : '',
        /* 裸 base64，去掉 `data:image/png;base64,` 前缀 —— 后台直接解码存文件 */
        png: drawn ? canvas.toDataURL('image/png').split(',')[1] : '',
        /* 签的时候屏幕上那一份免责原文。法务改了设置项，
           这一份也跟着变 —— 但**已经存下来的那些不会**，那才是记录的意义 */
        waiver: terms ? (terms.innerText || terms.textContent || '').trim() : '',
      };
    };

    show('type');
  }

  /* ── 4. 提交 ────────────────────────────────────────────────── */
  function submit(root) {
    var form = root.matches('form') ? root : root.closest('form');
    var done = document.querySelector('[data-tr-done]');
    if (!form || !form.dataset.endpoint) return;   /* 留空 = 走原生表单 */

    form.addEventListener('submit', function (e) {
      /* 拿不到后台配置时 eb-forms.js 会打上这个标记。试骑这张退不回原生
         表单（它的原生分支是服务端另一套 markup），所以这里只是不接管，
         下面照常提交、照常报错 —— 不假装成功。 */
      if (form.dataset.ebNative === 'true') return;

      /* 必填项交给浏览器自己拦（required + type=email），这里只管它通过之后的事 */
      if (!form.checkValidity()) return;
      e.preventDefault();

      var btn = form.querySelector('button[type="submit"]');
      if (btn && btn.disabled) return;             /* 连点两下不该交两单 */
      if (btn) btn.disabled = true;

      /* 字段名是 contact[...]（Shopify 原生表单只认这个前缀），发 JSON 时
         剥回裸键 —— 后台两条路收到的形状必须一样，否则要写两套解析。
         保修登记那条线用的是同一段。 */
      var data = {};
      new FormData(form).forEach(function (v, k) {
        var m = k.match(/^contact\[(.+)\]$/);
        data[m ? m[1] : k] = v;
      });

      var sig = root.trSignature ? root.trSignature() : null;
      if (sig) {
        data.signature_method = sig.method;
        data.signature_typed = sig.typed;
        data.signature_png = sig.png;
        data.waiver_text = sig.waiver;
        /* 隐藏字段里那份可能被截断过，别让它跟着上去混淆后台 */
        delete data.Signature;
      }

      /* Turnstile 自己往表单里插了 cf-turnstile-response，
         上面那圈 FormData 已经收到了。托管模式下人通常不用点，
         但脚本没加载完就提交时它是空的 —— 那就等一下再交，
         而不是发一个必然被后台拒掉的请求。 */
      if (form.querySelector('[data-tr-turnstile]') && !data['cf-turnstile-response']) {
        if (btn) btn.disabled = false;
        say(form, done && done.dataset.verify);
        return;
      }

      fetch(form.dataset.endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })
        .then(function (r) { if (!r.ok) throw new Error(r.status); })
        .then(function () {
          /* 就地换成「已提交」那一屏 —— 不跳页，
             「我到底约上了没有」是这一页最后一个真问题 */
          if (done) {
            done.hidden = false;
            form.replaceWith(done);
            done.scrollIntoView({ block: 'center', behavior: 'smooth' });
          }
        })
        .catch(function () {
          if (btn) btn.disabled = false;
          /* token 是一次性的，失败之后不换一个，重试必然再失败 */
          if (window.turnstile) window.turnstile.reset();
          say(form, done && done.dataset.error);
        });
    });
  }

  function say(form, text) {
    if (!text) return;
    var box = form.querySelector('[data-tr-msg]');
    if (!box) {
      box = document.createElement('p');
      box.className = 'eb-book__none';
      box.setAttribute('data-tr-msg', '');
      box.setAttribute('role', 'alert');
      box.style.color = 'var(--color-sale)';
      var submitRow = form.querySelector('.eb-book__submit');
      if (submitRow) submitRow.appendChild(box);
      else form.appendChild(box);
    }
    box.textContent = text;
  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-test-ride]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
